import { Icon, IconName } from '@bytel/trilogy-react';

type tagAnimatedProps = {
    isVisible: boolean;
    label: string;
};

export function TagAnimated({ label, isVisible }: Readonly<tagAnimatedProps>) {
    return (
        <div className={`animated-sticker ${isVisible ? 'show' : ''}`}>
            <span className={`tag is-success is-small `}>
                <Icon name={IconName.ADVISOR} />
                {label}
            </span>
        </div>
    );
}
